import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import api from '../../../components/api';

function useClients() {
  const [searchValue, setSearchValue] = React.useState<string>('');
  const { isLoading: loadingClientList, data: clientListRes } = useQuery(
    'getAllActiveClients',
    () => api.clients.getAllActive(),
  );

  const clientList = React.useMemo(() => {
    const resData = clientListRes?.data?.data;
    if (resData) {
      return resData.map((result) => {
        const address = `${result?.address?.streetAddress}, ${result?.address?.city}, ${result?.address?.state}, ${result?.address?.zipCode}`;
        const {
          name, id,
        } = result;
        return {
          title: name,
          id,
          address,
        };
      }).filter((result) => result?.title?.toLocaleLowerCase().includes(searchValue.toLowerCase()));
    } return [];
  }, [clientListRes, searchValue]);

  // navigate handler
  const navigate = useNavigate();
  //    will navigate to add client
  const navigateToAddClient = () => {
    navigate('/clients/add');
  };

  return {
    navigateToAddClient,
    searchValue,
    setSearchValue,
    clientList,
    loadingClientList,
  };
}

export default useClients;
